import React from 'react';
import FileComponent from 'shared/components/FileComponent';

const GerberFile = (props) => {
  const {
    inputId,
    label,
    text,
    parameters,
    errorMessage,
  } = props;
  const name = 'filename';
  const value = parameters[name];
  const isRequired = value === '' || value === undefined;

  return (
    <div className="form-group">
      <FileComponent
        id={inputId}
        label={label}
        text={text}
        fileName={value}
        isFileRequired={isRequired}
        {...props} />
      <span className="error">
        {errorMessage}
      </span>
    </div>
  );
};

GerberFile.defaultProps = {
  inputId: 'gerber-file',
  label: Spree.translations.upload_file,
  text: 'Browse file',
};

export default GerberFile;
